import inputsExtension from './jquery.inputs';
import isPartOfExtension from './jquery.isPartOf';
import behaviorExtension from './jquery.behaviors';
import componentExtension from './jquery.component';

export default Object.assign(
    {},
    inputsExtension,
    isPartOfExtension,
    behaviorExtension,
    componentExtension
);